/**
 * HQ 본부(브랜드) 정보 서비스.
 */
import hqApi from './hqApiClient';

export interface HqBrand {
  id: string;
  name: string;
  business_number?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
  address?: string | null;
  royalty_rate?: number | null;
  pii_sharing_agreed_at?: string | null;
  is_active: boolean;
  created_at?: string;
}

export interface HqBrandUpdate {
  name?: string;
  business_number?: string;
  contact_email?: string;
  contact_phone?: string;
  address?: string;
  royalty_rate?: number;
}

export const hqBrandService = {
  async get(): Promise<HqBrand> {
    const { data } = await hqApi.get<HqBrand>('/api/v1/hq/brand');
    return data;
  },

  async update(payload: HqBrandUpdate): Promise<HqBrand> {
    const { data } = await hqApi.put<HqBrand>('/api/v1/hq/brand', payload);
    return data;
  },
};
